import { debounce } from "lodash";
import React, { useCallback, useState } from "react";
import { useDispatch } from "react-redux";
import { Button, Form } from "semantic-ui-react";
import { newContact } from "../../../store/actions/contactActions";
import { phoneRegex } from "../../../utils/consts";

const ContactInfo = (props) => {
  const [ath, setAth] = useState(null);
  const [par1, setPar1] = useState(null);
  const [par2, setPar2] = useState(null);
  const [error, setError] = useState(null);
  const dispatch = useDispatch();

  const handleSubmit = () => {
    const toFirestore = {
      id: props.athId,
      athleteContact: ath,
      parentsContact: par1,
      parentsContact2: par2,
    };
    dispatch(newContact(toFirestore));
  };

  const inputChange = ({ target }) => {
    const { name } = target;
    const { value } = target;

    switch (name) {
      case "athContact":
        if (phoneRegex.test(value)) {
          setAth(value);
          setError(null);
        } else if (value) {
          setError("Invalid");
        } else {
          setAth(null);
        }
        break;

      case "parentContact1":
        if (phoneRegex.test(value)) {
          setPar1(value);
          setError(null);
        } else if (value) {
          setError("Invalid");
        } else {
          setPar1(null);
        }
        break;
      case "parentContact2":
        if (phoneRegex.test(value)) {
          setPar2(value);
          setError(null);
        } else if (value) {
          setError("Invalid");
        } else {
          setPar2(null);
        }
        break;

      default:
        break;
    }
  };

  const debouncedChangeHandler = useCallback(debounce(inputChange, 350), []);

  return (
    <div className="AdminAthleteActionImagesContainer">
      <div className="AdminAthleteActionImagesTitleButtonContainer">
        <h3>Contact Info</h3>

        {(props.data.athleteContact !== ath ||
          props.data.parentsContact !== par1 ||
          props.data.parentsContact2 !== par2) && (
          <div className="position-relative">
            <Button
              disabled={error}
              negative={error}
              floated="right"
              name="addPhotosHighSchoolButton"
              content={error ? error : "Save"}
              labelPosition="right"
              icon="phone"
              onClick={handleSubmit}
            />
          </div>
        )}
      </div>
      <Form.Field>
        <label>Athlete Contact</label>
        <input
          defaultValue={props.data.athleteContact}
          id="athContact"
          name="athContact"
          onChange={debouncedChangeHandler}
        />
      </Form.Field>
      <Form.Field>
        <label>Parent Contact 1</label>
        <input
          defaultValue={props.data.parentsContact}
          id="parentContact"
          name="parentContact1"
          onChange={debouncedChangeHandler}
        />
      </Form.Field>
      <Form.Field>
        <label>Parent Contact 2</label>
        <input
          defaultValue={props.data.parentsContact2}
          id="parentContact"
          name="parentContact2"
          onChange={debouncedChangeHandler}
        />
      </Form.Field>
    </div>
  );
};

export default ContactInfo;
